//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  layout: 'login',
  data: () => {
    return {
      isLoading: false,
      valid: true,
      loginDetails: {
        Email: '',
      },
      globalError: '' || null,
      formErrors: {} || null,
      successMessage: '' || null,
    }
  },
  computed: {
    organizationLogo() {
      return this.$store.state.localStorage.userData?.Personalization?.Logo
    },
  },
  methods: {
    validate() {
      return (this.valid = this.$refs.forgetPassForm.validate())
    },
    resetValidation() {
      this.globalError = '' || null
      this.formErrors = {} || null
      this.$refs.forgetPassForm.resetValidation()
    },
    async sendEmail() {
      if (!this.validate()) {
        return false
      }
      this.resetValidation()

      const $this = this
      this.isLoading = true

      await this.$axios
        .$post('/forgot-password/', this.loginDetails)
        .then((resp) => {
          this.$dialog.message.success(resp.Result)
          setTimeout(() => {
            $this.$router.push('/login/')
          }, 3000)
        })
        .catch((error) => {
          if (!error.response) {
            return error
          }
          if (error.response.data.FieldsError) {
            $this.formErrors = error.response.data.FieldsError
          }

          if (error.response.data.GlobalError) {
            this.globalError = error.response.data.GlobalError
          }
        })
        .then(() => {
          this.isLoading = false
        })
      return false
    },
  },
}
